<template xmlns="">
  <ul class="configurator-step-purpose" ref="purpose">

    

    <ConfiguratorStepPurposeItem
      v-for="(item, index) in options"
      v-bind:item="item"
      v-bind:isPurposeStep="true"
      v-bind:option="name"
      v-bind:key="item.id"
    />

    <li class="section-title" v-if="!selectedPurpose">
      <div>
        <i class="material-icons">error</i>
        Deine Auswahl hat keine Auswirkung auf die Preisbewertung deines Fahrzeugs.
      </div>
      
    </li>

    <p v-if="shouldZipBeVisible" class="form-text">
      <b>Wo steht das Fahrzeug? </b><br>
      <small>Deutsche PLZ bitte 5-stellig angeben:</small>
    </p>
    <div v-if="shouldZipBeVisible" class="form" ref="zipForm">
      <div class="input-wrapper">
        <input class="zip-input" v-model="zip" type="text" @input="onZipChange" pattern="\d*" maxlength="5" :class="[inputError ? 'error' : '']" />
      </div>
      <small v-if="inputError" class="input-error">Die eingegebene PLZ scheint ungültig zu sein.</small>
    </div>

    <li class="meta" v-if="selectedPurpose">
      <a @click.prevent="submit" tabindex="-1" :disabled="isDisabled" class="submit" :class="isDisabled && 'disabled'" title="Weiter" v-wave="{color: '#54a324',initialOpacity: 0.3,easing: 'ease-in'}">
        Weiter
      </a>
    </li>
  </ul>
</template>

<script>
import debounce from 'debounce';

import ConfiguratorStepExtrasItem from './ConfiguratorStepExtrasItem'
import ConfiguratorStepListItem from './ConfiguratorStepListItem'
import ConfiguratorStepPurposeItem from './ConfiguratorStepPurposeItem'
import {Api} from "../services/api";

export default {
  name: 'ConfiguratorStepPurpose',
  components: { ConfiguratorStepExtrasItem, ConfiguratorStepListItem, ConfiguratorStepPurposeItem },
  props: ['name', 'options'],
  data: function() {
    return {
      zip: null,
      location: null,
      inputError: false,
    }
  },
  computed: {
    emptyList: function() {
      return this.options == null || this.options.length == 0;
    },
    isDisabled: function() {
      return this.shouldZipBeVisible && (!this.location || !this.isValidZip);
    },
    selectedPurpose: function() {
      return this.$store.state.selected.purpose;
    },
    shouldZipBeVisible: function() {
      return this.selectedPurpose;
    },
    isValidZip: function () {
      return !!this.zip && this.zip.length >= 4 && this.zip.length <= 5;
    },
  },
  methods: {
    submit: function(event) {
      if (this.isDisabled) return false;
      if (this.shouldZipBeVisible) {
        this.$store.commit('toggleSingleOption', {name: 'zip', value: this.zip});
        this.$store.commit('toggleSingleOption', {name: 'location', value: this.location});
      }

      this.$store.dispatch('selectOption', {name: this.name });
    },
    onZipChange: debounce(function (e) {
      if (this.isValidZip && this.zip.length === 5) {
        this.$store.commit('toggleSingleOption', {name: 'zip', value: this.zip});
        Api.get(this.$store, "autocomplete").then(response => {
          if (response[0]) {
            this.location = response[0].id;
            this.inputError = false;
          } else {
            this.location = null;
            this.inputError = true;
          }
        });
      }
    }, 500)
  },
  watch: {
    selectedPurpose: function(newValue) {
      const purposeBox = this.$refs.purpose;
      setTimeout(() => {
        purposeBox.scrollTo({
          top: purposeBox.scrollHeight,
          left: 0,
          behavior: 'smooth'
        });
      }, 100);

      if (newValue === 'know_price' || !newValue) {
        this.zip = null;
      }
    },
    isValidZip: function(newValue) {
      if (!newValue) {
        this.location = null;
        this.inputError = false;
      } else {
        this.inputError = false;
      }
    },
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/vars";

* {
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 transparent;
}
*:hover {
  scrollbar-width: thin;
  scrollbar-color: #999999 transparent;
}
*::-webkit-scrollbar {
  width: 8px;
}
*::-webkit-scrollbar-track {
  background: transparent;
}
*::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  border-radius: 20px;
}
*::-webkit-scrollbar-thumb:hover {
  background-color: #999999;
}

.section-title {
  color: $green;
  font-size: 13px;
  margin: 10px 15px 10px 20px;
  font-family: "Asap", sans-serif;
  line-height: 18px;
  div {
    display:flex;
    align-items: center;
  }
  .material-icons {
    font-size:15px;
    margin-right: 5px;
    font-family: 'Material Icons';
  }

}

.form-text {
  margin: 10px 20px 15px;
  line-height: 15px;
}

.spacer {
  height: 5px;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  margin: 10px;
}

.input-wrapper {
  position: relative;

  .zip-input {
    padding-left: 32px;
  }

  &::before {
    content: 'D−';
    font-weight: 700;
    font-size: 16px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 10px;
    z-index: 99;
    width: 22px;
  }
}

ul {
  margin: 0;
  padding: 10px 0;
  list-style-type: none;
  position: absolute;
  top: 62px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: scroll;
}

li.meta {
  padding: 10px 20px;
}

li.empty {
  padding: 0 20px;
  color: #888;
  font-size: 12px;
  line-height: 20px;
}

.form {
  padding: 0 20px;
}

input[type="number"],
input[type="text"] {
  border: 1px solid #dadada;
  border-radius: 0px;
  padding: 0 10px;
  line-height: 40px;
  display: block;
  font-size: 14px;
  width: 100%;
  height: 50px;
}

input[type="number"].error,
input[type="text"].error  {
  border: 1px solid #bf141c;
}

.input-error {
  margin-top: 10px;
  display: inline-block;
  color: #bf141c;
}

input[type="number"]:focus,
input[type="text"]:focus {
  outline: none;
}

.submit {
  height: auto;
  width: auto;
  font-size: 14px;
  line-height: 20px;
  display:block;
  width: 100%;
  border: 1px solid #54a324;
  color: #54a324;
  background: transparent;
  border-radius: 23px;
  padding: 10px;
  text-align: center;
  font-weight: 600;
  cursor: pointer;
  @media (hover: hover) {
    &:not(.disabled):hover {
      text-decoration: none;
      background-color: #eee;
    }
  }
}

.submit:focus {
  outline: none;
}

.submit.disabled {
  pointer-events: none;
  opacity: 0.25;
  cursor: default;
}

</style>



// WEBPACK FOOTER //
// src/components/ConfiguratorStepPurpose.vue